import * as Sentry from '@sentry/react';

// Map environment from existing app env, then NODE_ENV
const env = process.env.REACT_APP_APP_ENV || process.env.NODE_ENV || 'development';

Sentry.init({
  dsn: 'https://435ac4250900ddf3fd567f7b30815102@o4509152042287104.ingest.us.sentry.io/4510314615537664',
  environment: env,
  release: process.env.REACT_APP_RELEASE,
  sendDefaultPii: true,
});

export { Sentry };


